/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import KfreTwoYearsComputedJournalEvent from "parog-web/models/kfre-two-years-computed-journal-event";
import { computeKfreAsPercent } from "parog-web/utils/compute-kfre";
import BaseKfreEditionForm from "../abstract/base-kfre-edition-form";

export default class KfreTwoYearsEditionFormComponent extends BaseKfreEditionForm {
  static forcDisplayName = "Score de risque rénal à 2 ans";

  static fullComponentId = "kfre/two-years-edition-form";

  static journalEventClass = KfreTwoYearsComputedJournalEvent;
  computeScore(o) {
    return computeKfreAsPercent({
      age: parseFloat(o.age as string),
      sex: o.sex as "male" | "female",
      dfg: parseFloat(o.dfg as string),
      rac: parseFloat(o.rac as string),
      years: 2
    }).toString();
  }
}
